/**
 * Marker stamped onto the plain object returned by Book's axios `processError`
 * path (`apps/book/src/plugins/axios.js`). Nested axios-retry interceptor
 * re-entries key on this marker (MOVEPRO-BOOK-AB); Sentry `beforeSend` also
 * drops unhandled rejections of these objects (MOVEPRO-BOOK-AF) because the
 * interceptor already decided whether to `captureException`.
 */
export const BOOK_PROCESSED_ERROR_MARKER = '__bookProcessedError' as const;

export function isBookProcessedError(value: unknown): boolean {
    return Boolean(
        value && typeof value === 'object' && (value as Record<string, unknown>)[BOOK_PROCESSED_ERROR_MARKER] === true,
    );
}

/**
 * Whether a Sentry event should be dropped because it is a re-report of an
 * axios-processed plain object (unhandled rejection or accidental
 * `captureException` of the processed shape).
 */
export function shouldDropBookProcessedSentryEvent(hint: { originalException?: unknown } | undefined): boolean {
    return isBookProcessedError(hint?.originalException);
}
